// src/modules/app-views/_apps/appmulti/leads/pages/Init/actions/menuButton.js
// *******************************************************************************
// MENU BUTTON — Leads list has no parametrization or additional actions.
// *******************************************************************************
const leadsInitMenuButton = () => ({
  action: 'dropdownMenu',
  dropdownItems: [],
});

export default leadsInitMenuButton;
